export default __webpack_public_path__ + "static/media/search-off.f326cfeb.svg";